import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format IRT amount — e.g. 1,234,567,890 → ۱.۲ میلیارد */
export function formatIRT(amount: number | null | undefined): string {
  if (amount == null) return "—";
  const abs = Math.abs(amount);
  const sign = amount < 0 ? "-" : "";
  if (abs >= 1_000_000_000_000) return `${sign}${(abs / 1_000_000_000_000).toFixed(1)} تریلیون`;
  if (abs >= 1_000_000_000) return `${sign}${(abs / 1_000_000_000).toFixed(1)} میلیارد`;
  if (abs >= 1_000_000) return `${sign}${(abs / 1_000_000).toFixed(1)} میلیون`;
  if (abs >= 1_000) return `${sign}${(abs / 1_000).toFixed(0)}K`;
  return `${sign}${abs.toLocaleString()}`;
}

/** Format a rate 0–1 as percentage */
export function formatRate(rate: number | null | undefined, decimals = 1): string {
  if (rate == null) return "—";
  return `${(rate * 100).toFixed(decimals)}%`;
}

/** Format integer with comma separators */
export function formatNumber(n: number | null | undefined): string {
  if (n == null) return "—";
  return n.toLocaleString("fa-IR");
}

/** Compact number: 1,200 → ۱.۲K, 1,500,000 → ۱.۵M */
export function formatCompact(n: number | null | undefined): string {
  if (n == null) return "—";
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return String(n);
}

export function recommendationColor(rec: string) {
  switch (rec) {
    case "launch_now": return { bg: "var(--color-launch-bg)", text: "var(--color-launch)", badge: "badge-launch" };
    case "controlled_pilot": return { bg: "var(--color-pilot-bg)", text: "var(--color-pilot)", badge: "badge-pilot" };
    case "monitor": return { bg: "var(--color-monitor-bg)", text: "var(--color-monitor)", badge: "badge-monitor" };
    case "no_go": return { bg: "var(--color-nogo-bg)", text: "var(--color-nogo)", badge: "badge-nogo" };
    default: return { bg: "#f3f4f6", text: "#374151", badge: "" };
  }
}

export function recommendationIcon(rec: string) {
  switch (rec) {
    case "launch_now": return "🚀";
    case "controlled_pilot": return "🔬";
    case "monitor": return "👀";
    case "no_go": return "🚫";
    default: return "❓";
  }
}

export function recommendationLabel(rec: string) {
  switch (rec) {
    case "launch_now": return "راه‌اندازی کن";
    case "controlled_pilot": return "آزمایش کنترل‌شده";
    case "monitor": return "پایش و ارزیابی مجدد";
    case "no_go": return "بدون توجیه";
    default: return rec;
  }
}

export function confidenceLabel(grade: string) {
  switch (grade) {
    case "A": return "داده مستقیم داخلی";
    case "B": return "داده رسمی تأیید شده";
    case "C": return "تخمین مدل";
    case "D": return "داده‌های ناقص";
    default: return grade;
  }
}
